import { ICommand, IDefineCommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';

angular
  .module('capability-ng-survey')
  .factory(
    'loadSurveyResourcesCommand',
    function updateTopicOptInsCommandDefinition(
      $q: ng.IQService,
      defineCommandORM: IDefineCommand,
      loadResourceDetailCommand: ICommand,
      log: any
    ) {
      return defineCommandORM(
        'loadSurveyResourcesCommand',
        function updateTopicOptInsCommand(deferred: ng.IDeferred<IQuery[]>, resourceIDs: number[]) {
          const resourcePromises = _4.map(resourceIDs, (id) => loadResourceDetailCommand(id));

          $q.all(resourcePromises)
            .then(() => {
              deferred.resolve();
            })
            .catch((error) => {
              log.issue('Failed to load survey resources!');
              deferred.reject(error);
            });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-survey/src/commands/load_survey_resources.ts